import { LitElement, html, css } from 'lit-element';
import { customElement, property } from 'lit/decorators.js';

import '@shoelace-style/shoelace/dist/components/dropdown/dropdown';
import '@shoelace-style/shoelace/dist/components/avatar/avatar';
import '@shoelace-style/shoelace/dist/components/menu/menu.js';
import '@shoelace-style/shoelace/dist/components/menu-item/menu-item.js';

import { styles as sharedStyles } from '../styles/shared-styles';
import { UserInfo } from 'firebase/auth';
import { Layout } from '../state/pages';
import { NavigateEvent } from '../events';
import SlMenuItem from '@shoelace-style/shoelace/dist/components/menu-item/menu-item.js';
import { switchLayout } from '../media-query';

@customElement('user-menu')
export class Usermenu extends LitElement {

  static get styles() {
    return [
      sharedStyles,
      css`
      sl-dropdown [slot='trigger'] {
          cursor: pointer;
        }
      `
    ];
  }

  getInitials() {
    if (!this.user) return null;
    if (!this.user.displayName) {
      return this.user.email?.charAt(0).toUpperCase();
    }
    const words = this.user.displayName.split(' ');
    let initials = '';
    for (let i = 0; i < words.length; i++) {
      initials += words[i].charAt(0);
      if (initials.length === 2) break;
    }
    return initials.toUpperCase();
  }

  renderLoginMenu() {
    return html`
      <sl-menu-item data-href="/account?returningUser" value="login" @click=${this.menuClick}>Aanmelden</sl-menu-item>
      <sl-menu-item data-href="/account" value="register" @click=${this.menuClick}>Registreren</sl-menu-item>`;
  }

  renderUserMenu() {
    return html`
      <sl-menu-item data-href="/account" value="Account" @click=${this.menuClick}>Mijn account</a></sl-menu-item>`;
  }

  render() {

    return html`
    <sl-dropdown>
    <sl-avatar slot="trigger"
      .class?=loggedin 
      icon=${this.user ? "person-fill-check" : "person-exclamation"} 
      initials="${this.getInitials()}" 
      image="${this?.user?.photoURL}" 
      label="${this?.user?.displayName}"
      style="--size: ${switchLayout(this.layout, "1.5rem", "1.5rem", "2.0rem", "2.0rem")};"
      >
    </sl-avatar>
    <sl-menu>
      ${!!this.user ? this.renderUserMenu() : this.renderLoginMenu()}
      <sl-menu-item data-href="/account/list" value="Mijn lijst" @click=${this.menuClick}>Watchlist</sl-menu-item>
    </sl-menu>
    </sl-dropdown>`;
  }

  menuClick(event: TouchEvent) {
    event.preventDefault();
    const clickedItem: SlMenuItem = event.currentTarget as SlMenuItem;
    const url: string = clickedItem.getAttribute("data-href") as string;
    this.dispatchEvent(new NavigateEvent({ url }));
  }

  @property({ attribute: true, type: Number })
  layout = Layout.PHONE;

  @property({ type: Object })
  user: UserInfo | null = null;

}
